import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import NavBarKS from "../../components/NavBarKS";
import CustomerAliasListModal from "./CustomerAliasListModal";
import moment from "moment";

class GIBUserList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			manual: false,
			content: [],
			total: 0,
			loading: false,
			searching: false,
			searchQuery: undefined,
			page: 0,
			size: 10,
			modal: false,
			defineAccountType: [
				{value: "", label: 'Tümü'},
				{value: "GIBPORTAL", label: 'GİB Portal Kullanıcısı'},
				{value: "ENTEGRASYON", label: 'Doğrudan Entegrasyon'},
				{value: "OZELENTEGRASYON", label: 'Özel Entegratör'}
				]
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let target = this.props.name;
		let params = {
			url: '/gibuser/fetch' + '/' + target +'?page=' + page + '&size=' + size + searchQuery + sortStr,
			method: "get",
		};
		self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		request(params)
			.then(function (response) {
				self.setState({
					page: page,
					size: size,
					total: response.data.totalElements,
					content: response.data.content,
					loading: false,
					searching: false
				});
				self.props.reload(false);
			}).catch(function (error) {
			self.setState({loading: false, searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	render() {
		const columns = [
			{
				Header: <div style={{textAlign: 'center'}}>VKN/TCKN</div>,
				width: "20%",
				accessor: "identifier",
				Cell: row => (<div style={{textAlign: "center"}}>
					{row.identifier}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>Unvan</div>,
				width: "50%",
				accessor: "title",
				Cell: row => (<div style={{textAlign: "left"}}>
					{row.title}
				</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>Kayıt Türü</div>,
				width: "10%",
				accessor: "accountType",
				Cell: row => (
					<div>{row.accountType === 'OZELENTEGRASYON' ? "Özel Entegratör" : (row.accountType === 'ENTEGRASYON' ? "Doğrudan Entegrasyon" : (row.accountType === 'GIBPORTAL' ? "GİB Portal Kullanıcısı" : "Bilinmeyen"))}</div>)

			},
			{
				Header: <div style={{textAlign: 'center'}}>İlk Kayıt Zamanı</div>,
				width: "20%",
				accessor: "firstCreationTime",
				Cell: (row) => (
					<div>{moment(row.firstCreationTime).isValid() ? moment(row.firstCreationTime).format("DD-MM-YYYY HH:mm:ss") : ''}</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>İşlemler</div>,
				width: "10%",
				accessor: "",
				sortable: false,
				Cell: row => (
					<a><label
						onClick={() => this.setState({vknTckn: row.identifier, modal: true, formattedName: row.title})}
						className="fas fa-eye" style={{color: '#4fc43b', fontSize: '1.2em', cursor: 'pointer'}}/></a>
				)
			}
		];

		const fields = [
			{
				label: "VKN/TCKN",
				accessor: "identifier",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Unvan",
				accessor: "Title",
				type: "text",
				operator: "=",
			},

			{
				label: "İlk Kayıt Zamanı (Başlangıç)",
				accessor: "min_firstCreationTime",
				type: "datetime",
				operator: ">=",
			},
			{
				label: "İlk Kayıt Zamanı (Bitiş)",
				accessor: "max_firstCreationTime",
				type: "datetime",
				operator: "<=",
			},
			{
				label: "Kayıt Türü",
				accessor: "accountType",
				type: "select",
				operator: "=",
				selectData: this.state.defineAccountType
			},
		];

		return (
			<div className="row baseBackground">

				<NavBarKS/>

				<div className="col-sm-12 satirBasi">
					<div className="card-header">
						<h4 className="card-title">GİB Kayıtlı Kullanıcılar</h4>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-sm-12">
								<div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
									<DetailedSearch fields={fields}
													loading={this.state.searching}
													onSearch={this.handleSearch}/>
								</div>
							</div>
						</div>
					</div>
					<div className="card-body">
						<div className=" row">
							<div className="col-sm-12">
								<Table columns={columns}
									   loading={this.state.loading}
									   loadingText="Kayıtlar getiriliyor..."
									   content={this.state.content}
									   total={this.state.total}
									   page={this.state.page}
									   manual={this.state.manual}
									   size={this.state.size}
									   options={["5", "10", "20", "50", "100"]}
									   fetchData={this.fetchData}
								/>
							</div>
						</div>
					</div>
					{this.state.modal &&
					<CustomerAliasListModal
						vknTckn={this.state.vknTckn}
						modal={this.state.modal}
						title={"Müşteri Etiketleri (" + this.state.vknTckn + "-" + this.state.formattedName + ")"}
						toggleModal={(flag) => this.setState({modal: flag})}/>
					}
				</div>
			</div>
		);
	}
}

export default GIBUserList;